import { cn } from '@lib/utils';
import type { HTMLAttributes, ReactNode } from 'react';

type CompanyLogoPreviewProps = {
  fallback: ReactNode;
  logoAlt: string;
  logoClassName?: string;
  logoUrl?: string;
} & HTMLAttributes<HTMLDivElement>;

export const CompanyLogoPreview = (props: CompanyLogoPreviewProps) => {
  const { className, fallback, logoAlt, logoClassName, logoUrl, ...otherProps } = props;

  return (
    <div
      className={cn('flex items-center justify-center overflow-hidden rounded-xl bg-gray-100', className)}
      {...otherProps}
    >
      {logoUrl ? (
        <img
          alt={logoAlt}
          className={cn('h-full w-full object-contain', logoClassName)}
          src={logoUrl}
        />
      ) : (
        fallback
      )}
    </div>
  );
};
